<template>
  <section class="e-retailer-wrapper" :id="retailers.AnchorLinkId">
    <h2 class="title" v-if="retailers.Title" v-titleSup="retailers.Title"></h2>
    <div
      role="region"
      aria-roledescription="carousel"
      class="slider-wrapper"
      v-if="retailers"
      :aria-label="retailers.Title ? retailers.Title : ''"
    >
      <div class="carousel-wrapper" data-carousel>
        <Carousel
          v-if="retailers.ERetailers"
          navigationPrevLabel='<svg aria-hidden="true" fill="#ffffff" stroke="#ffffff" aria-label="Previous"><use xlink:href="#arrow-left" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>'
          navigationNextLabel='<svg fill="#ffffff" stroke="#ffffff" aria-hidden="true" aria-label="Next"><use xlink:href="#arrow-right" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>'
          :perPageCustom="[
            [290, 2.4],
            [480, 3.4],
            [1024, 5.6],
          ]"
          :navigationEnabled="navEnable"
          :paginationEnabled="pageEnable"
          paginationColor="#333333"
          paginationActiveColor="#ffffff"
          :paginationSize="24"
          :nextAriaLabel="nextAriaLabel"
          :prevAriaLabel="prevAriaLabel"
        >
          <Slide v-for="item in retailers.ERetailers" :key="item.Logo.Src">
            <a
              v-hrefsafe="item.RedirectUri.Url"
              @click="datalayerClickPush(item)"
              target="_blank"
            >
              <img
                :src="item.Logo.Src"
                :data-src="item.Logo.Src"
                :alt="item.Logo.Alt"
                decoding="async"
                class="retailer-img lazy"
              />
            </a>
          </Slide>
        </Carousel>
      </div>
      <div class="no-retailers-wrapper" v-if="retailers.ERetailers.length == 0">
        <p>No Retailers</p>
      </div>
    </div>
    <div class="retailers-info-wrapper">
      <details
        v-if="retailers.Description && retailers.AccordionTitle"
        class="accordion arrow"
        :open="retailers.OpenAccordionByDefault"
      >
        <summary>
          <p v-htmlsafe="retailers.AccordionTitle" class="accordiantitle"></p>
        </summary>
        <div
          class="accordion__content"
          v-htmlsafe="retailers.Description"
        ></div>
      </details>
      <div
        class="accordiantitle"
        v-else-if="retailers.AccordionTitle && retailers.Description == ''"
        v-htmlsafe="retailers.AccordionTitle"
      ></div>
      <div
        class="accordion__content"
        v-else
        v-htmlsafe="retailers.Description"
      ></div>
    </div>
  </section>
</template>

<script>
// import Carousel from "../carousel/Carousel.vue";
// import Slide from "../carousel/Slide.vue";

export default {
  name: 'ERetailersVuecarousel',
  // components: {
  //   Carousel,
  //   Slide,
  // },
  props: {
    retailers: {
      type: Object,
      required: true,
    },
    prevAriaLabel: {
      type: String,
      required: true,
      default: 'Previous Page',
    },
    nextAriaLabel: {
      type: String,
      required: true,
      default: 'Next Page',
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      navEnable: true,
      pageEnable: false,
    };
  },
  mounted() {
    this.resizeHandler();
  },
  computed: {},
  methods: {
    resizeHandler() {
      window.onresize = () => {
        this.windowWidth = window.innerWidth;
        this.dotSlider();
      };
      this.dotSlider();
    },
    dotSlider() {
      if (this.windowWidth < 768) {
        this.navEnable = false;
      } else {
        this.navEnable = true;
      }
    },
    datalayerClickPush(data) {
      window.dataLayer.push(data.Datalayer);
    },
  },
  destroyed() {
    this.sliderInstance.clear();
  },
};
</script>
